import { render, staticRenderFns } from "./serviceInformationDetail.vue?vue&type=template&id=2d822780&scoped=true"
import script from "./serviceInformationDetail.vue?vue&type=script&lang=js"
export * from "./serviceInformationDetail.vue?vue&type=script&lang=js"
import style0 from "./serviceInformationDetail.vue?vue&type=style&index=0&id=2d822780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d822780",
  null
  
)

export default component.exports